import { Box, Button, Container, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import BackBtn from "../../widgets/BackBtn";
import PageTitle from "../../widgets/PageTitle";
import { getHeader, toastError } from "../../utils/util";
import axios from "axios";
import { API_ENDPOINT } from "../../utils/constants";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const CreateProject = () => {
  const { id } = useParams();
  const [formData, setFormData] = useState({
    name: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const response = await axios.post(
        `${API_ENDPOINT}/partner/create-project/${id}`,
        formData,
        getHeader()
      );
      toast.success(response.data.message);
      setTimeout(() => {
        document.location.reload();
      }, 500);
    } catch (error) {
      toastError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <PageTitle>Create New Project</PageTitle>

      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 4,
          p: 4,
          borderRadius: 2,
          boxShadow: 1,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="h6" gutterBottom>
          Project Details
        </Typography>

        <TextField
          fullWidth
          margin="normal"
          label="Project Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          inputProps={{ maxLength: 100 }}
          helperText="Enter a name for your project (max 100 characters)"
        />

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            Error: {error}
          </Typography>
        )}

        <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{ px: 4 }}
            disabled={isLoading}
          >
            {isLoading ? "Creating..." : "Create Project"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default CreateProject;
